import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Heading, Text } from '@chakra-ui/react';
import { Title } from '../text/title';
import { ButtonPrimary } from '../buttons/primary';
import { ButtonSecondary } from '../buttons/secondary';
import { HSpacer } from '../spacers/spacer-horizontal';
import { colors } from '../theme/colors';
import { When } from '../utils/when';
import { LoadingDot } from '../loading-dot';
export var ErrorModal = function ErrorModal(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, {
      fontSize: "sm",
      textAlign: "center",
      textTransform: "uppercase",
      children: /*#__PURE__*/_jsx(Title, {
        fontSize: "14x",
        color: colors.red,
        children: t('GENERIC_ERROR_TITLE')
      })
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "24px"
    }), /*#__PURE__*/_jsx(Text, {
      align: "center",
      children: t('GENERIC_ERROR_DESCRIPTION')
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "32px"
    }), /*#__PURE__*/_jsxs(ButtonPrimary, {
      bgColor: colors.green,
      disabled: props.isLoading,
      onClick: function onClick() {
        return props.onConfirm(props.selectedAction);
      },
      children: [/*#__PURE__*/_jsx(When, {
        value: !props.isLoading,
        children: t('TRY_AGAIN')
      }), /*#__PURE__*/_jsx(When, {
        value: props.isLoading,
        children: /*#__PURE__*/_jsx(LoadingDot, {})
      })]
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "8px"
    }), /*#__PURE__*/_jsx(ButtonSecondary, {
      disabled: props.isLoading,
      bgColor: "none",
      borderColor: colors.green,
      textColor: colors.green,
      onClick: function onClick() {
        return props.onClose();
      },
      children: t('BACK')
    })]
  });
};